<template>
    <div id="organizationMapBox2">
        <div id="organizationMap2"></div>
    </div>
</template>

<script>
function noop() {}
import AMap from "AMap"; // 引入高德地图
import { post } from "@/api/requrestHttp";
export default {
    name: "mapLocation",
    props: {
        val: {
            default: ""
        },
        orgId: {
            default: null
        },
        onSuccess: {
            type: Function,
            default: noop
        },
        disabled: {
            default: false
        }
    },
    components: {},
    data() {
        return {
            baseForm: { longitude: "", latitude: "" }
        };
    },
    computed: {},
    methods: {
        changeLocation(e) {
            //this.debounce(this.debounce(e),1000)
        },
        //根据输入地址转换经纬度并标记

        setmarkerFunc(longitude, latitude) {
            this.mapmarker.setPosition([longitude, latitude]);

            // this.mapcontainer.add(this.mapmarker);
            this.mapcontainer.setFitView(this.mapmarker);
        },
        //初始化地图插件的方法
        mapInit(containerId) {
            this.mapcontainer = new AMap.Map(containerId, {
                // mapStyle: "amap://styles/darkblue",
                //  mapStyle: "amap://styles/4f2131e7288788c62b63fc7957674ba0",
                zoom: 15,
                zooms: [3, 20],
                expandZoomRange: true,
                center: [118.006294,32.779161] //初始化地图中心点
            });
            this.mapmarker = new AMap.Marker({
                map: this.mapcontainer
            });

            if (this.val) {
                let splitList =this.val.split("%");
                if(splitList.length>1){
                    splitList.forEach(item => {
                        let s = item.split(",");
                        this.setmarkerFunc(s[0], s[1]);
                    })
                }else {
                    let s = this.val.split(",");
                    this.setmarkerFunc(s[0], s[1]);
                }

            }
            //定义地图坐标点击事件
            this.mapcontainer.on("click", e => {
                if (this.disabled) {
                    return false;
                }
                this.setmarkerFunc(e.lnglat.getLng(), e.lnglat.getLat());

                // this.$emit(
                //     "input",
                //     `${e.lnglat.getLng()},${e.lnglat.getLat()}`
                // );
                this.onSuccess(`${e.lnglat.getLng()},${e.lnglat.getLat()}`);
            });
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.mapInit("organizationMap2");
        });
    },
    created() {},
    watch: {
        val(newVal, old) {
            console.log(newVal)
            if (newVal) {
                let s = newVal.split(",");
                this.setmarkerFunc(s[0], s[1]);
            }
        }
    }
};
</script>
<style lang="less" >
#organizationMap2 {
    width: 100%;
    height: 100%;
}
</style>
